// src/services/payableBillsService.js
import api from '../api/api';

/**
 * ============================
 * PAYABLE BILLS (REGLAS)
 * ============================
 */

export async function createPayableBill(payload) {
  const { data } = await api.post('/api/payable-bills', payload);
  return data;
}

export async function getPayableBills({ active } = {}) {
  const params = {};
  if (active === true) params.active = 'true';
  if (active === false) params.active = 'false';

  const { data } = await api.get('/api/payable-bills', { params });
  return data;
}

export async function getPayableBillById(id) {
  const { data } = await api.get(`/api/payable-bills/${id}`);
  return data;
}

export async function updatePayableBill(id, payload) {
  const { data } = await api.put(`/api/payable-bills/${id}`, payload);
  return data;
}

export async function togglePayableBill(id) {
  const { data } = await api.patch(`/api/payable-bills/${id}/toggle`);
  return data;
}

/**
 * ============================
 * DASHBOARD
 * ============================
 */

export async function getDashboardRange(startISO, endISO) {
  const { data } = await api.get('/api/payable-bills/dashboard/range', {
    params: { start: startISO, end: endISO },
  });
  return data;
}

export async function getDashboardWeek(dateISO) {
  const { data } = await api.get('/api/payable-bills/dashboard/week', {
    params: { date: dateISO },
  });
  return data;
}

export async function getUpcoming(days = 7) {
  const { data } = await api.get('/api/payable-bills/dashboard/upcoming', {
    params: { days },
  });
  return data;
}

/**
 * ============================
 * PAGOS
 * ============================
 */

export async function payBillPayment(paymentId, payload = {}) {
  const { data } = await api.post(
    `/api/payable-bills/payments/${paymentId}/pay`,
    payload
  );
  return data;
}

export async function skipBillPayment(paymentId) {
  const { data } = await api.post(
    `/api/payable-bills/payments/${paymentId}/skip`
  );
  return data;
}
